import { Resource } from '../../../http/resource/resource.model';
// tslint:disable: variable-name

export class QueryOptions extends Resource {
  data: Array<any>;
}

